<app-navbar></app-navbar>
<mat-sidenav-container>
  <mat-sidenav class="admin-sidenav"
               mode="side"
               [fixedInViewport]="true"
               [fixedTopGap]="56"
               [fixedBottomGap]="0"
               [opened]="true">
    <div class="fx-col-h-100">
      <div class="fx-col-h-100 fx-gap-20 pl-10 pr-10">
        <app-menu-module></app-menu-module>
        <div class="flex-spacer"></div>
        <footer class="drawer-footer fx-row-w-100 fx-gap-10 fx-h-center">
          <div class="pb-1">© SOKO District {{ date | date: 'yyyy' }}. All rights reserved.</div>
        </footer>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="pl-10 pr-10 main-content-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>
